module.exports = "/assets/f63ba7b32dd57fa35e53110ab3528c0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/G4.png
// module id = 1392
// module chunks = 0